import { generateAbsoluteUrl } from './URLParamUtil';
import { findOrCreateElementInHead } from './HtmlElementUtil';
import { isNullOrUndefined } from '@as-react/common-utils';
export const generateRelatedProductPageLinks = (canonicalUrl, currentPage, sizeParameter, totalPages, updateCanonicalLinkElement = true) => {
    const linkPrevDomElement = findOrCreateElementInHead('link[rel="prev"]', 'link', { rel: 'prev' });
    const linkNextDomElement = findOrCreateElementInHead('link[rel="next"]', 'link', { rel: 'next' });
    if (updateCanonicalLinkElement) {
        const linkCanonicalDomElement = findOrCreateElementInHead('link[rel="canonical"]', 'link', {
            rel: 'canonical',
        });
        if (!isNullOrUndefined(linkCanonicalDomElement)) {
            linkCanonicalDomElement.href = generateAbsoluteUrl(canonicalUrl, currentPage, sizeParameter);
        }
    }
    if (!isNullOrUndefined(linkPrevDomElement)) {
        if (currentPage > 0) {
            const prevPage = currentPage - 1;
            linkPrevDomElement.href = generateAbsoluteUrl(canonicalUrl, prevPage, sizeParameter);
        }
        else {
            linkPrevDomElement.parentNode.removeChild(linkPrevDomElement);
        }
    }
    if (!isNullOrUndefined(linkNextDomElement)) {
        if (currentPage < totalPages - 1) {
            const nextPage = currentPage + 1;
            linkNextDomElement.href = generateAbsoluteUrl(canonicalUrl, nextPage, sizeParameter);
        }
        else {
            linkNextDomElement.parentNode.removeChild(linkNextDomElement);
        }
    }
};
